import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { getLoginConfig, type LoginConfigResponseDto } from 'shared/services';

export const useGetLoginConfig = () => {
  return useQuery<LoginConfigResponseDto>(QUERY_KEYS.loginConfig(), {
    queryFn: getLoginConfig,
  });
};
